var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{attrs:{"paintings":_vm.paintings},on:{"deleted":_vm.deleteElement,"dropCollection":_vm.clear}})}
var staticRenderFns = []

export { render, staticRenderFns }